import './index.less';
import React, { useEffect, useState } from 'react';
import AlertIcon from './assets/alert-circle-filled.svg';
import { REACT_APP_PUBLIC_URL } from '@/constants/Constants';
import { hasFeatureFlag } from '@/services';
import { getActiveSummary, getWarningSummary } from './actions';
import account from '@/api/operator/cgi/smb/manage/account';

export default function ThrowControlAlert(props: { style?: {} | undefined }) {
  const { style = {} } = props;

  const [accountList, setAccountList] = useState<any[]>([]);
  const [warningList, setWarningList] = useState<any[]>([]);
  const [isAllWarning, setIsAllWarning] = useState(true);
  const [customerContent, setCustomerContent] = useState('');
  const [showTips, setShowTips] = useState(false);
  const setAccount = () => {
    window.open(`${REACT_APP_PUBLIC_URL}/agency/credit-system`);
  };
  const viewDoc = () => {
    window.open('https://doc.weixin.qq.com/doc/w3_AJoAcQaaACgCN6k72fRxNR4Gk0zlq?scode=AJEAIQdfAAoWOLF6wLAJoAcQaaACg&isEnterEdit=1');
  };

  useEffect(() => {
    Promise.all([getActiveSummary({}), getWarningSummary({})]).then((res: any) => {
      const accountList = res[0]?.data?.list || [];
      const warningList = res[1]?.data?.ad_customer_list || [];
      console.log('length', accountList.length, warningList.length);
      setShowTips(!(accountList.length === 0 && warningList.length === 0));

      setAccountList(accountList);
      setWarningList(warningList);
    });
  }, []);

  const initText = () => {
    let text = '';
    if (accountList.length > 0) {
      setIsAllWarning(false);
      // 部分受限
      if (warningList.length > 0) {
        text = `系统检测你有${accountList.length + warningList.length
          }个主体信誉等级低，其中${accountList.length
          }个主体已触达账户数限制，今日将限制可投的账户数，系统默认为你启用昨日花费较高的账户，你可于账户列表查看「账户是否启用」状态并`;
      } else {
        // 全部受限
        text = `系统检测你有${accountList.length ?? '-'
          }个主体信誉等级低且触达账户数限制，今日将限制可投的账户数，系统默认为你启用昨日花费较高的账户，你可于账户列表查看「账户是否启用」状态并`;
      }
    } else {
      setIsAllWarning(true);
      // 全部预警
      text = `系统检测你有${warningList.length ?? '-'
        }个主体信誉等级偏低，本周进入预警状态，若账户数达上限将触发可投账户数限制，请持续关注以免影响日后投放，你可至`;
    }
    setCustomerContent(text);
  };

  useEffect(() => {
    initText();
  }, [accountList, warningList]);

  if (!hasFeatureFlag('enable_account_red_line')) {
    return null;
  }

  return (
    <>
      {showTips ? (
        <div className="throw-control-alert-container">
          <div className="throw-control-alert" style={style}>
            <span className="throw-control-alert__icon">
              <img src={AlertIcon} alt="警告" />
            </span>
            <div className="throw-control-alert__content">
              {customerContent}
              {/* 系统检测你的主体：{getText()}触达账户数限制，今日将限制可投的账户数，系统默认为你启用昨日花费较高的账户， 你可于账户列表页查看「账户是否启用」并 */}
              {isAllWarning ? (
                <>
                  <span onClick={setAccount}>信誉体系</span>查看详情
                </>
              ) : (
                <span onClick={setAccount}>调整启用账户</span>
              )}
              ，如有疑问可咨询对接腾讯营销运营或
              <span onClick={viewDoc}>查看详细文档</span>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
